export default "__VITE_ASSET__DsfSYaLQ__"